const VIBE_MAPPING: VibeData[] = [
  {
    condition: /sunny|clear/i,
    effect: null,
    title: "Gramatik - Just Jammin'",
    url: 'https://www.youtube.com/embed/xTA_FexW3qU?si=-24uKliID_MvHyRa',
  },
  {
    condition: /cloudy/i,
    effect: 'cloudy',
    title: 'Guts - And The Living Is Easy',
    url: 'https://www.youtube.com/embed/2tvx3k6AJwg?si=rYY6wFM6v34cujz5',
  },
  {
    condition: /overcast/i,
    effect: 'fog',
    title: 'Emancipator - Safe In The Steep Cliffs',
    url: 'https://www.youtube.com/embed/BJIPmHKhYfk?si=VeCW55eVDgiuSj3X',
  },
  {
    condition: /sleet|rain|drizzle|shower/i,
    effect: 'rain',
    title: "Tomppabeats - You're Cute",
    url: 'https://www.youtube.com/embed/039QyF-zwWA?si=bjPaUK6kPXTuc0YO',
  },
  {
    condition: /thunder|lightning/i,
    effect: 'storm',
    title: 'Miles Davis - So What',
    url: 'https://www.youtube.com/embed/ylXk1LBvIqU?si=pihJslrZ71boiRI-',
  },
  {
    condition: /snow|blizzard|ice pellets/i,
    effect: 'snow',
    title: 'Chet Baker - Almost Blue',
    url: 'https://www.youtube.com/embed/z4PKzz81m5c?si=lOppSokXJmn17liE',
  },
  {
    condition: /fog|haze|mist/i,
    effect: 'fog',
    title: 'Charles Mingus - Goodbye Pork Pie Hat',
    url: 'https://www.youtube.com/embed/sxz9eZ1Aons?si=F_vB0yXRLZPLrGrr',
  },
];

export const DEFAULT_VIBE: VibeData = {
  condition: /.*/i,
  title: 'Default Jazz Vibes',
  url: 'https://www.youtube.com/embed/DefaultJazz',
  effect: null,
};

export interface VibeData {
  condition: RegExp;
  title: string;
  url: string;
  effect: string | null; // e.g. 'rain', 'snow', 'fog'
}

export const getVibeForCondition = (condition: string): VibeData => {
  const found = VIBE_MAPPING.find(({ condition: regex }) => regex.test(condition));
  return found || DEFAULT_VIBE;
};
